import type { Root } from 'react-dom/client'
import { createRoot } from 'react-dom/client'

/**
 * Type safe createRoot which guards against the root ID not existing
 */
export const createRootOrThrow = (): Root => {
  const element = document.getElementById('app')
  if (element === null) throw new Error(`Unable to find element with ID "app"`)
  return createRoot(element)
}
